import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "shouldPauseAnimation", "reportId"];
import { useState, useEffect, forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const TransitionWidget = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      children,
      shouldPauseAnimation = false,
      reportId
    } = props,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);
  const [canTransition, setCanTransition] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setCanTransition(true);
    }, 300);
  }, []);
  return /*#__PURE__*/_jsx("div", Object.assign({
    id: `${reportId}`
  }, restProps, {
    ref: ref,
    "data-can-transition": !shouldPauseAnimation && canTransition,
    children: children
  }));
});
export default TransitionWidget;